var map = {
	"./MERS-Black-White.png": "ceaf",
	"./MERS-Green-Black.png": "e3d9",
	"./MERS-Green-White.png": "1e24",
	"./MERS-White.png": "18a8",
	"./alerus-dark.svg": "bac29",
	"./alerus-mobile.svg": "9136",
	"./alerus.svg": "191a",
	"./managed-docs.svg": "2f18",
	"./myMerslogo.png": "fb91",
	"./tax-forms.svg": "777e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "33db";